<loading [isLoading]="isLoading"></loading>
<div class="panelDetailRoute" *ngIf="isVisible">
  <!-- Primera sección -->
  <div class="header_panel">
    <!-- Componente de lista de reportes -->
    <div class="btnMenuSecondary">
      <app-report-list
        [isRutas]="true"
        [identifier]="this.Data.identifier"
      ></app-report-list>
    </div>

    <!-- <div class="btnBack">
      <a class="btnReturn" (click)="CancelButton()" matTooltip="Regresar"> </a>
    </div> -->
    <!-- ? -->
    <div *ngIf="'Bloquear autos ruptela' | permissionFilter">
      <a
        class="btnBlokingActions"
        *ngIf="isVisibleBloking"
        (click)="OpenBlokingDialog()"
      >
        <mat-icon aria-hidden="false" aria-label="Example home icon"
          >{{ blokingIcon }}</mat-icon
        >
      </a>
    </div>

    <!-- Botón regresar-->
    <a class="btnReturn" (click)="onClickReturn()" matTooltip="Regresar"
      ><mat-icon>arrow_back_ios</mat-icon></a
    >

    <!-- Encabezado -->
    <div class="container header-background">
      <img src="/assets/img/carA.png" class="img-car" />
    </div>

    <!-- VIN-->
    <div class="container">
      <div class="row">
        <label class="titlePanel vin-title">VIN {{ this.Data.identifier }}</label>
        <label class="subtitlePanel"> {{this.Data.description}}</label>
        <label class="titlePanel"> {{this.Data.startDate}} - {{this.Data.endDate}}</label>
      </div>
    </div>

    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="selectTab($event)"
      id="panelRouteResumeTabContent">
      <mat-tab>
        <ng-template mat-tab-label>
          <label matTooltip="Resumen del Activo" matTooltipPosition="above" id="routeResumeTab">
            <mat-icon class="example-tab-icon">info</mat-icon>
            Resumen
          </label>
        </ng-template>
        <ng-template matTabContent>
          <!-- Segunda sección -->
          <div class="container">
            <div class="row text-header">
              <div class="section-header-background">
                <h3>Datos Generales</h3>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-md-5 item-resume">
                  <p class="property_text">Distancia Recorrida</p>
                  <img class="item-icon" src="/assets/img/distance.png" />
                  <p class="property_value">{{this.Data.distance}}</p>
                </div>
                <div class="col-md-6 item-resume">
                  <p class="property_text">Velocidad Promedio</p>
                  <img class="item-icon" src="/assets/img/velocity.png" />
                  <p class="property_value">{{this.Data.velocityProm}}</p>
                </div>
                <div class="col-md-6 item-resume">
                  <p class="property_text">Duración</p>
                  <img class="item-icon" src="/assets/img/time.png" />
                  <p class="property_value">{{this.Data.durationTime}}</p>
                </div>
                <div class="col-md-6 item-resume">
                  <p class="property_text">Cantidad de Paradas</p>
                  <img class="item-icon" src="/assets/img/stops.png" />
                  <p class="property_value">{{this.Data.cantStops}}</p>
                </div>
              </div>
            </div>

            <!-- <div class="container">
          <div class="row text-header">
            <div class="col-md-6 bold">Fecha Inicio</div>
            <div class="col-md-6 bold">Fecha Fin</div>
          </div>
          <div class="row text-header">
            <div class="col-md-6">
              {{ this.Data.startTime}}
            </div>
            <div class="col-md-6">
              {{ this.Data.endTime}}
            </div>
          </div>
        </div> -->
            <!-- <label class="header_panel titlePanel text-center">Resumen de Ruta</label>
        <div class="container route-resume" >
          <div class="row">
            <div class="col-md-6 text-center property">
              <img class="imagenPanel" src="/assets/img/distance.png" /><br />
              <label class="titleProperty">Dist. Recorrida</label>
              <br><label class="detailProperty">{{this.Data.distance}}</label>
            </div>
            <div class="col-md-6 text-center property">
              <img class="imagenPanel" src="/assets/img/odometro.png" /><br />
              <label class="titleProperty">Veloc. Prom</label>
              <br><label class="detailProperty">{{this.Data.velocityProm}}</label>
            </div>
            <div class="col-md-6 text-center property">
              <img class="imagenPanel" src="/assets/img/startPoint.png" /><br />
              <label class="titleProperty">Inicio</label>
               <br><label><a routerLink="." (click)="onFlyToStartLocation()">{{this.Data.startLocationStr}}</a></label> 
            </div>
            <div class="col-md-6 text-center property">
              <img class="imagenPanel" src="/assets/img/endPoint.png" /><br />
              <label class="titleProperty">Fin</label>
              <br><label><a routerLink="." (click)="onFlyToEndLocation()">{{this.Data.endLocationStr}}</a></label> 
            </div>
          </div>
        </div> -->

            <!-- <div class="container">
          <div class="row">
            <button mat-button color="primary" class="btnBuscar" (click)="onClickDetailLocation()">
              Detalle del Activo
            </button>
          </div>
        
        </div> -->
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <label matTooltip="" matTooltipPosition="above" id="routeResumeStepsTab">
            <mat-icon class="example-tab-icon">alt_route</mat-icon>
            Trazabilidad de Ruta
          </label>
        </ng-template>
        <ng-template matTabContent><panel-detail-routeSteps id="routeResumeSteps"></panel-detail-routeSteps></ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="">
    <div class="section-footer-background">
    </div>
  </div>
</div>
